<script setup>
import Header from '../Formularios/Header.vue'
import Intro from '../Formularios/Intro.vue'
import { useForm } from '@inertiajs/inertia-vue3';
</script>
<template>
    <Header :servicio="servicio" />
    <div class="contenido-wrapper">
        <Intro :servicio="servicio" />
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <p style="display:block; padding: 6px; background-color: #FDFFCF;">
                            La protesta ciudadana es una herramienta donde las y los ciudadanos(as) podrán presentar una queja cuando, con acciones u omisiones, un servidor público responsable del trámite, niegue la gestión sin causa justificada, altere o incumpla con lo declarado en el Registro Municipal de Trámites y Servicios.
                        </p>
                        <form @submit.prevent="submit()">
                            <h2>Tus Datos</h2>
                            <div class="form-group mt-4">
                                <div style="cursor: pointer;">
                                    <input style="cursor: pointer;" v-model="form.anonimo" type="checkbox" id="anonimo" @change="changeAnonimo">
                                    <label style="cursor: pointer;display:inline;" for="anonimo">Quiero denunciar de forma anónima</label>
                                </div>
                            </div>
                            <div class="row" v-if="!form.anonimo">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                        <label>Nombre(s) <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.nombre" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Paterno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_paterno" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Materno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_materno" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <p style="color: red;line-height: 1rem;" v-if="form.anonimo">El teléfono celular y correo electrónico son opcionales si no se proporcionan no se podrá notificar del seguimiento de su queja.</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                        <label>Correo electrónico <small>(opcional)</small></label>
                                        <input v-model="form.email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                        <label>Teléfono celular  <small>(opcional)</small></label>
                                        <input v-model="form.telefono" minlength="10" maxlength="10" type="tel" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.tipo_de_protesta }">
                                <label>Tipo de protesta <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <div>
                                    <div class="form-check pt-1">
                                        <input class="form-check-input" v-model="form.tipo_de_protesta" type="radio" id="radio1" value="Negación del Trámite">
                                        <label class="form-check-label" for="radio1">Negación del trámite </label>
                                        <span class="radio-info">Algún Servidor Público le negó el poder realizar el trámite o servicio sin causa justificada, altero reglas o procedimientos, incumplió con los plazos de respuesta o le solicitó dinero adicional.</span>
                                    </div>
                                    <div class="form-check pt-4">
                                        <input class="form-check-input" v-model="form.tipo_de_protesta"  type="radio" id="radio2" value="Incumplimiento del trámite">
                                        <label class="form-check-label" for="radio2">Incumplimiento del trámite </label>
                                        <span class="radio-info">Incumplimiento a lo establecido en el catálogo de trámites y servicios – solicitud de datos, documentos y/o la realización de trámites adicionales.</span>
                                    </div>
                                    <div class="form-check pt-4">
                                        <input class="form-check-input" v-model="form.tipo_de_protesta"  type="radio" id="radio3" value="Deficiencias en el trámite">
                                        <label class="form-check-label" for="radio3">Deficiencias en el trámite </label>
                                        <span class="radio-info">Considera que el trámite o servicio solicitado se brindó de manera indebida o con deficiencias.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.tramite_servicio }">
                                <label>Nombre de trámite, servicio, inspección, verificación o visita domiciliaria: <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <input v-model="form.tramite_servicio" type="text" class="form-control">
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.fecha }">
                                        <label>Fecha de los hechos<span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input type="date" v-model="form.fecha" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.lugar_de_los_hechos }">
                                        <label>Lugar de los hechos<span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.lugar_de_los_hechos" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.descripcion_de_la_situacion }">
                                <label>Descripción de la situación. <small>(explica de manera detallada la situación de la vulneración)</small><span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <textarea v-model="form.descripcion_de_la_situacion" class="form-control" rows="5"></textarea>
                            </div>
                            <h2>Adjunta la siguiente documentación opcional:</h2>
                            <p>Puedes subir máximo 3 documentos opcionales (fotografías, archivos en pdf, word) que ayuden en el seguimiento de la queja.</p>
                            <div class="form-group border-bottom-1 mb-5" :class="{ 'not-valid': form.errors.archivo_1 }">
                                <p class="mb-2">Archivo 1 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_1 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_1">
                                    <label class="custom-file-label" for="archivo_1" data-txt-button="Selecciona un archivo">{{ (form.archivo_1) ? form.archivo_1.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>
                            <div class="form-group mb-5" :class="{ 'not-valid': form.errors.archivo_2 }">
                                <p class="mb-2">Archivo 2 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_2 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_2">
                                    <label class="custom-file-label" for="archivo_2" data-txt-button="Selecciona un archivo">{{ (form.archivo_2) ? form.archivo_2.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.archivo_3 }">
                                <p class="mb-2">Archivo 3 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_3 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_3">
                                    <label class="custom-file-label" for="archivo_3" data-txt-button="Selecciona un archivo">{{ (form.archivo_3) ? form.archivo_3.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>

                            <div class="form-group mt-4" :class="{ 'not-valid': form.errors.aviso_de_privacidad }">
                                <div style="cursor: pointer;">
                                    <input style="cursor: pointer;" v-model="form.aviso_de_privacidad" type="checkbox" id="aviso_de_privacidad">
                                    <label style="display:inline;" for="aviso_de_privacidad">Confirmo que he leído y acepto el <a href="/descargas/avisodeprivacidad.pdf" style="text-decoration: underline;" target="_blank">Aviso de Privacidad</a> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                </div>
                            </div>
                            <div class="form-group-submit">
                                <div class="response-output show" v-if="form.hasErrors">
                                    <p>Por favor completa los campos faltantes</p>
                                    <ul>
                                        <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                    </ul>
                                </div>
                                <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' :
                                    'Enviar queja'
                                }}</button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        servicio: Object,
    },
    data() {
        return {
            form: useForm({
                anonimo: false,
                aviso_de_privacidad: false,
                servicio_id: this.servicio.id,
                slug: this.servicio.slug,
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                telefono: '',
                email: '',
                tramite_servicio: '',
                tipo_de_protesta: '',
                lugar_de_los_hechos: '',
                fecha: '',
                descripcion_de_la_situacion: '',
                archivo_1: '',
                archivo_2: '',
                archivo_3: '',
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(route('servicios.formulario.save'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        changeAnonimo() {
            if (this.form.anonimo) {
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = 'Anónimo';
            } else {
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = '';
            }
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.form-group.not-valid select, .form-group.not-valid textarea {
    border-color: #CD1518;
}
.form-check-label{
    cursor: pointer;
    font-weight: bold;
    margin-bottom: 0;
}
.radio-info{
    display: block;
    font-size: 16px;
    line-height: 1.4em;
}
</style>
